export default {
  REACT_APP_SERVER_URL: process.env.REACT_APP_SERVER_URL,
  FILE_IMAGE_URL: process.env.REACT_APP_IMAGES_URL,
  FILE_CURRENT_STATUS_IMAGES: process.env.REACT_APP_CURRENT_STATUS_IMAGES,
  REACT_APP_FILE_DOWNLOAD_URL: process.env.REACT_APP_FILE_DOWNLOAD_URL,
  REACT_APP_TINY_EDITOR: process.env.REACT_APP_TINY_EDITOR,
};
